module.exports = __webpack_public_path__ + "0754d37e4340a2389e1dcba73dae6987.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-13.png
// module id = 1998
// module chunks = 0